import axios from "axios";
import i18n from "../i18n";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Notifications
import {addNotification} from "../notifications/notifications-actions";

// Constants
export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_ERROR = "FETCH_USERS_ERROR";
export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_ERROR = "FETCH_USER_ERROR";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";
export const SEND_WELCOME_USER_REQUEST = "SEND_WELCOME_USER_REQUEST";
export const SEND_WELCOME_USER_SUCCESS = "SEND_WELCOME_USER_SUCCESS";
export const SEND_WELCOME_USER_ERROR = "SEND_WELCOME_USER_ERROR";
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const UPDATE_USER_STATUS_REQUEST = "UPDATE_USER_STATUS_REQUEST";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_ERROR = "UPDATE_USER_STATUS_ERROR";
export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";

export const readUser = (userId) => {
    return async (dispatch) => {
        try {
            dispatch(fetchUserRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.get(`/api/users/${userId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchUserSuccess, fetchUserError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchUserError));
        }
    };
};

const fetchUserRequest = () => {
    return {
        type: FETCH_USER_REQUEST
    };
};

const fetchUserSuccess = (payload) => {
    return {
        type: FETCH_USER_SUCCESS,
        payload
    };
};

const fetchUserError = (errorMessage) => {
    return {
        type: FETCH_USER_ERROR,
        errorMessage
    };
};

export const readUsers = () => {
    return async (dispatch) => {
        try {
            dispatch(fetchUsersRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.get('/api/users', { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchUsersSuccess, fetchUsersError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchUsersError));
        }
    };
};

const fetchUsersRequest = () => {
    return {
        type: FETCH_USERS_REQUEST
    };
};

const fetchUsersSuccess = (payload) => {
    return {
        type: FETCH_USERS_SUCCESS,
        payload
    };
};

const fetchUsersError = (errorMessage) => {
    return {
        type: FETCH_USERS_ERROR,
        errorMessage
    };
};

export const createUser = (user, sendWelcomeEmail) => {
    return async (dispatch) => {
        try {
            dispatch(createUserRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/users', user, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createUserSuccess, createUserError));

            // Create notification for update user success
            dispatch(addNotification({
                message: i18n.t("users:toaster.success.createUser"),
                color: 'green',
                icon: 'tick'
            }));

            sendWelcomeEmail && dispatch(sendWelcomeUser(user));

        } catch (err) {
            dispatch(utilsLib.response(err, createUserError));
        }
    };
};

const createUserRequest = () => {
    return {
        type: CREATE_USER_REQUEST
    };
};

const createUserSuccess = (payload) => {
    return {
        type: CREATE_USER_SUCCESS,
        payload
    };
};

const createUserError = (errorMessage) => {
    return {
        type: CREATE_USER_ERROR,
        errorMessage
    };
};

export const sendWelcomeUser = (user) => {
    return async (dispatch) => {
        try {
            dispatch(sendWelcomeUserRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/users/send-welcome/', user, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, sendWelcomeUserSuccess, sendWelcomeUserError));
        } catch (err) {
            dispatch(utilsLib.response(err, sendWelcomeUserError));
        }
    };
};

const sendWelcomeUserRequest = () => {
    return {
        type: SEND_WELCOME_USER_REQUEST
    };
};

const sendWelcomeUserSuccess = (payload) => {
    return {
        type: SEND_WELCOME_USER_SUCCESS,
        payload
    };
};

const sendWelcomeUserError = (errorMessage) => {
    return {
        type: SEND_WELCOME_USER_ERROR,
        errorMessage
    };
};

export const updateUser = (user, sendWelcomeEmail) => {
    return async (dispatch) => {
        try {
            dispatch(updateUserRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.put(`/api/users/${user._id}`, user, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateUserSuccess, updateUserError));

            // Create notification for update user success
            dispatch(addNotification({
                message: i18n.t("profile:toaster.success.updateUser"),
                color: 'green',
                icon: 'tick'
            }));

            sendWelcomeEmail && dispatch(sendWelcomeUser(user));

        } catch (err) {
            dispatch(utilsLib.response(err, updateUserError));
        }
    };
};

export const updateUserPassword = (user) => {
    return async (dispatch) => {
        try {
            dispatch(updateUserRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/users/password', user, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateUserSuccess, updateUserError));

            // Create notification for update password user success
            dispatch(addNotification({
                message: i18n.t("profile:toaster.success.updateUserPassword"),
                color: 'green',
                icon: 'tick'
            }));
        } catch (err) {
            dispatch(utilsLib.response(err, updateUserError));
        }
    };
};

const updateUserRequest = () => {
    return {
        type: UPDATE_USER_REQUEST
    };
};

const updateUserSuccess = (payload) => {
    return {
        type: UPDATE_USER_SUCCESS,
        payload
    };
};

const updateUserError = (errorMessage) => {
    return {
        type: UPDATE_USER_ERROR,
        errorMessage
    };
};

export const updateUserStatus = (user) => {
    return async (dispatch) => {
        try {
            dispatch(updateUserStatusRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.put(`/api/users/${user._id}/status`, user, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateUserStatusSuccess, updateUserStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateUserStatusError));
        }
    };
};

const updateUserStatusRequest = () => {
    return {
        type: UPDATE_USER_STATUS_REQUEST
    };
};

const updateUserStatusSuccess = (payload) => {
    return {
        type: UPDATE_USER_STATUS_SUCCESS,
        payload
    };
};

const updateUserStatusError = (errorMessage) => {
    return {
        type: UPDATE_USER_STATUS_ERROR,
        errorMessage
    };
};

export const deleteUser = (user) => {
    return async (dispatch) => {
        try {
            dispatch(deleteUserRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.delete(`/api/users/${user._id}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteUserSuccess, deleteUserError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteUserError));
        }
    };
};

const deleteUserRequest = () => {
    return {
        type: DELETE_USER_REQUEST
    };
};

const deleteUserSuccess = (payload) => {
    return {
        type: DELETE_USER_SUCCESS,
        payload
    };
};

const deleteUserError = (errorMessage) => {
    return {
        type: DELETE_USER_ERROR,
        errorMessage
    };
};